"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Windows = void 0;
const desktop_window_1 = require("./desktop_window");
const osr_window_1 = require("./osr_window");
class Windows {
    // ---------------------------------------------------------------------------
    /**
     *
     * @returns Window object of the window this was called from.
     */
    static Self() {
        return new Promise((resolve, reject) => {
            overwolf.windows.getCurrentWindow(async (result) => {
                var _a;
                if (result.window.type === "Background" /* Background */) {
                    reject('background page doesn\'t have window');
                }
                switch (result.window.type) {
                    case "Desktop" /* Desktop */: {
                        const window = new desktop_window_1.DesktopWindow(null);
                        await window.assureCreated();
                        return resolve(window);
                    }
                    case "OffScreen" /* Offscreen */: {
                        const window = new osr_window_1.OSRWindow(null);
                        await window.assureCreated();
                        return resolve(window);
                    }
                    default:
                        reject(`unknown window type: ${(_a = result === null || result === void 0 ? void 0 : result.window) === null || _a === void 0 ? void 0 : _a.type}`);
                }
            });
        });
    }
    // ---------------------------------------------------------------------------
    /**
     * Get an existing window object with the given ID.
     * @param id ID of the window to get
     * @returns Window object with the given ID if exists.
     */
    static FromId(id) {
        return new Promise((resolve, reject) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            overwolf.windows.getWindow(id, result => {
                var _a;
                if (!result.success) {
                    reject(result.error);
                }
                if (result.window.type === "Background" /* Background */) {
                    reject('background page doesn\'t have window');
                }
                switch (result.window.type) {
                    case "Desktop" /* Desktop */: {
                        return resolve(new desktop_window_1.DesktopWindow(null, id));
                    }
                    case "OffScreen" /* Offscreen */: {
                        return resolve(new osr_window_1.OSRWindow(null, id));
                    }
                    default:
                        reject(`unknown window type: ${(_a = result === null || result === void 0 ? void 0 : result.window) === null || _a === void 0 ? void 0 : _a.type}`);
                }
            });
        });
    }
}
exports.Windows = Windows;
//# sourceMappingURL=windows.js.map